enum MeetingStatus {
  Pending,
  InProgress,
  Expired,
}

export default MeetingStatus;
